/**
 * DemoModeBanner — sticky top banner shown only in tabs operating under
 * the demo session token. Makes it impossible to confuse a demo session
 * with a real client session.
 *
 * Mount this at the top of any layout (Dashboard, AthletePrograms, etc.)
 * It self-checks via `isDemoTab()` and renders nothing otherwise.
 */
import { isDemoTab } from "@/context/AuthContext";
import { FlaskConical } from "lucide-react";

export default function DemoModeBanner() {
    if (!isDemoTab()) return null;
    return (
        <div
            data-testid="demo-mode-banner"
            className="bg-amber-600 text-black text-[11px] tracking-[0.25em] uppercase font-bold py-2 px-4 text-center flex items-center justify-center gap-2"
            role="status"
        >
            <FlaskConical className="w-3.5 h-3.5" />
            Demo Mode · Test Stripe · No real charges · Refresh to see coach changes
        </div>
    );
}
